export default {
  common: {
    breadcrumb: {
      home: 'ホーム',
    },
    cta: '「飛狼」の事業について、ぜひ詳しくご覧ください',
  },
  heroTitle: 'UI/UX デザイン＆開発',
  heroSubtitle: 'UI/UX Design & Development',
  heroDesc: 'ユーザーのニーズを核とし、UI/UXデザインと開発力を融合させることで、優れた体験と実質的なビジネス価値を兼ね備えたデジタルプロダクトを創出します。',
  intro: [
    'ユーザーのニーズやビジネスシーンを起点とし、ユーザーリサーチ、情報設計、インタラクションデザイン、UIビジュアルデザイン、フロントエンド開発を網羅した一貫したサービスを提供します。',
    '企業の事業内容やユーザーの利用習慣を深く理解した上で、複雑な業務ロジックを直感的かつ効率的で使いやすいプロダクト体験へと落とし込み、技術的な要件も踏まえながら、デザインと開発の連携を推進して実装を実現します。',
    '企業向け管理システム、業務プラットフォーム、あるいはユーザー向けのデジタル製品に至るまで、私たちは製品の体験と機能を継続的に最適化することで、企業の製品価値向上とユーザー満足度の向上を支援します。',
  ],
  servicesTitle: '業務範囲',
  servicesTitleEn: 'Our Services',
  servicesTitleDesc: '「飛狼」は、設計から開発まで一貫したきめ細やかなサービスで、ゼロから作り上げます。',
  services: [
    {
      icon: 'uiux/manufacturing.svg',
      title: 'モバイルアプリ',
      titleEn: 'Mobile Application',
      desc: 'スマートフォン、タブレット、スマートウォッチなどのモバイル端末を対象に、UI/UXデザインと開発力を融合させ、デバイスや利用シーンに応じた直感的かつスムーズで一貫性のあるユーザー体験を創出します。これにより、'
      + '企業のデジタルサービスをより多くの端末へと展開できるよう支援します。',
    },
    {
      icon: 'uiux/aerospace.svg',
      title: 'ウェブページ',
      titleEn: 'Web',
      desc: '企業公式サイト、Webアプリケーション、管理画面を対象に、ユーザーリサーチ、UI/UXデザイン、フロントエンド・バックエンド開発のサービスを提供し、'
      + '明確かつ効率的で使いやすいデジタルプラットフォームを構築します。',
    },
    {
      icon: 'uiux/utilities.svg',
      title: 'ミニプログラム',
      titleEn: 'Mini Program',
      desc: '製品の企画・設計（UI/UX）、機能開発からリリース・運用保守に至るまで、WeChatミニプログラムに関するワンストップサービスを提供します。企業の業務ニーズとユーザーの利用シーンを融合させ、'
      + '利便性が高く効率的なデジタルアプリケーションを構築するとともに、継続的な保守と機能のアップデートにより、システムの安定稼働を保証します。',
    },
  ],
  solutionsTitle: 'ソリューション',
  solutionsTitleEn: 'Our Solutions',
  solutionsDesc: '当社の設計・開発チームは豊富な業界経験を有し、ニーズを起点としつつ、世界を見据えた視点で取り組んでいます。',
  solutions: [
    {
      icon: 'uiux/consumer.svg',
      title: '消費',
      titleEn: 'Consumer',
      desc: '日常の消費シーンを念頭に、便利で直感的なデジタル製品体験を創出します。',
    },
    {
      icon: 'uiux/defense.svg',
      title: '医療システム',
      titleEn: 'Healthcare System',
      desc: '医療機器企業を対象とし、内部管理から外部業務までを網羅する総合的なデジタル化システム。',
    },
    {
      icon: 'uiux/hotel.svg',
      title: '企業向けサービス',
      titleEn: 'Business Dashboard',
      desc: '企業の業務データと重要情報を統合し、可視化ダッシュボードを通じて管理および意思決定の効率を向上させます。',
    },
    {
      icon: 'uiux/medal.svg',
      title: 'ファイナンス',
      titleEn: 'Finance',
      desc: '金融サービスのプロセスを簡素化し、明確かつ効率的で使いやすいデジタル体験を提供します。',
    },
    {
      icon: 'uiux/profile.svg',
      title: 'ニュース ＆ ソーシャル',
      titleEn: 'Information & Community',
      desc: '情報、Q&A、インタラクティブな機能を組み合わせ、ユーザーの参加度とプラットフォームの活性度を高めます。',
    },
    {
      icon: 'uiux/shopping-cart.svg',
      title: 'ECショッピング',
      titleEn: 'E-Commerce',
      desc: '商品の閲覧・購入から注文管理に至るまで、スムーズで直感的なオンラインショッピング体験を実現します。',
    },
  ],
  contact: 'お問い合わせ',
};
